// import React, { useContext, useEffect, useRef, useState } from 'react';
// import { motion, useScroll, useTransform, useSpring } from 'framer-motion';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { 
//   ShoppingBag, 
//   Headphones, 
//   Shield, 
//   Truck, 
//   ArrowRight,
//   Star,
//   Search,
//   ShoppingCart,
//   ChevronRight,
//   Package,
//   RefreshCw,
//   Phone,
//   Zap,
//   Award,
//   TrendingUp,
//   Heart,
//   Sparkles,
//   Gift,
//   CheckCircle2,
//   Eye // Add Eye icon for consistency
// } from 'lucide-react';
// import { useTheme } from 'components/Theme/ThemeProvider';
// import { useNavigate } from 'react-router-dom';
// import addToCart from 'helpers/addToCart';
// import Context from "../../context";
// import LikeButton from '../../components/ProductLike/LikeButton'; 
// import { summaryApi } from "../../common"; 

// gsap.registerPlugin(ScrollTrigger);

// const LandingPage = () => {
//   const { colors } = useTheme();
//   const { fetchUserAddToCart } = useContext(Context);
//   const [scrolled, setScrolled] = useState(false);
//   const [featuredProducts, setFeaturedProducts] = useState([]);
//   const [loadingProducts, setLoadingProducts] = useState(true);
//   const [productRatings, setProductRatings] = useState({});
//   const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
//   const heroRef = useRef(null);
//   const featuresRef = useRef(null);
//   const productsRef = useRef(null);
//   const servicesRef = useRef(null);
//   const navigate = useNavigate()

//   const { scrollYProgress } = useScroll();
//   const scaleProgress = useSpring(scrollYProgress, {
//     stiffness: 100,
//     damping: 30,
//     restDelta: 0.001
//   });

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 20);
//     window.addEventListener('scroll', handleScroll);
    
//     const handleMouseMove = (e) => {
//       setCursorPosition({ x: e.clientX, y: e.clientY });
//     };
//     window.addEventListener('mousemove', handleMouseMove);

//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//       window.removeEventListener('mousemove', handleMouseMove);
//     };
//   }, []);

//   useEffect(() => {
//     // Hero title animation
//     gsap.fromTo('.hero-title-word',
//       { 
//         y: 100, 
//         opacity: 0,
//         rotationX: -90
//       },
//       {
//         y: 0,
//         opacity: 1,
//         rotationX: 0,
//         duration: 1.2,
//         stagger: 0.1,
//         ease: 'power4.out',
//         scrollTrigger: {
//           trigger: heroRef.current,
//           start: 'top 80%'
//         }
//       }
//     );

//     // Floating animation for hero elements
//     gsap.to('.floating-element', {
//       y: -30,
//       duration: 2.5,
//       repeat: -1,
//       yoyo: true,
//       ease: 'sine.inOut',
//       stagger: 0.2
//     });

//     // Products reveal animation
//     gsap.fromTo('.product-reveal',
//       {
//         scale: 0.8,
//         opacity: 0,
//         rotationY: 45,
//       },
//       {
//         scale: 1,
//         opacity: 1,
//         rotationY: 0,
//         duration: 1,
//         stagger: 0.15,
//         ease: 'back.out(1.5)',
//         scrollTrigger: {
//           trigger: productsRef.current,
//           start: 'top 70%',
//           toggleActions: 'play none none reverse'
//         }
//       }
//     );

//     // Service cards stagger
//     gsap.fromTo('.service-card',
//       {
//         x: -100,
//         opacity: 0,
//         rotationY: -30
//       },
//       {
//         x: 0,
//         opacity: 1,
//         rotationY: 0,
//         duration: 1.2,
//         stagger: 0.2,
//         ease: 'power3.out',
//         scrollTrigger: {
//           trigger: servicesRef.current,
//           start: 'top 70%'
//         }
//       }
//     );

//     // Parallax effect for images
//     gsap.utils.toArray('.parallax-img').forEach((img) => {
//       gsap.to(img, {
//         y: -50,
//         ease: 'none',
//         scrollTrigger: {
//           trigger: img,
//           start: 'top bottom',
//           end: 'bottom top',
//           scrub: 1
//         }
//       });
//     });
//   }, []);

//   const heroProducts = [
//     {
//       id: 1,
//       name: "iPhone 15 Pro Max",
//       tagline: "Titanium. So strong. So light.",
//       price: "₦24,999",
//       image: "https://images.unsplash.com/photo-1678652197831-2d180705cd2c?w=800&h=800&fit=crop",
//       badge: "NEW",
//       color: "from-blue-500 to-purple-600"
//     },
//     {
//       id: 2,
//       name: "AirPods Pro",
//       tagline: "Adaptive Audio. Now playing.",
//       price: "₦5,999",
//       image: "https://images.unsplash.com/photo-1606841837239-c5a1a4a07af7?w=800&h=800&fit=crop",
//       badge: "POPULAR",
//       color: "from-purple-500 to-pink-600"
//     },
//     {
//       id: 3,
//       name: "Apple Watch Ultra",
//       tagline: "Adventure awaits.",
//       price: "₦18,999",
//       image: "https://images.unsplash.com/photo-1579586337278-3befd40fd17a?w=800&h=800&fit=crop",
//       badge: "FEATURED",
//       color: "from-orange-500 to-red-600"
//     }
//   ];

//   console.log("featuredProducts:", featuredProducts);


//   const fetchProductRating = async (productId) => {
//   try {
//     const response = await fetch(`${summaryApi.getReviews.url}/${productId}`, {
//       method: summaryApi.getReviews.method,
//       credentials: 'include'
//     });
//     const data = await response.json();
    
//     if (data.data && data.data.length > 0) {
//       const totalRating = data.data.reduce((sum, review) => sum + review.rating, 0);
//       const averageRating = totalRating / data.data.length;
      
//       setProductRatings(prev => ({
//         ...prev,
//         [productId]: {
//           average: averageRating,
//           count: data.data.length
//         }
//       }));
//     }
//   } catch (error) {
//     console.error(`Error fetching rating for product ${productId}:`, error);
//   }
// }

//   // Fetch real featured products from backend
//  useEffect(() => {
//   const fetchFeaturedProducts = async () => {
//     try {
//       setLoadingProducts(true);
//       const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080';
//       const response = await fetch(`${backendUrl}/api/product/featured-products`);
//       const data = await response.json();
      
//       if (data.success && data.data) {
//         setFeaturedProducts(data.data);
//         // Fetch ratings for each featured product
//         data.data.forEach(product => {
//           fetchProductRating(product._id);
//         });
//       }
//     } catch (error) {
//       console.error('Error fetching featured products:', error);
//     } finally {
//       setLoadingProducts(false);
//     }
//   };

//   fetchFeaturedProducts();
// }, []);


//   const services = [
//     {
//       icon: <Shield className="w-12 h-12" />,
//       label: "PROTECTION",
//       title: "Extended Warranty & Insurance",
//       description: "Comprehensive coverage for all your devices with screen repair included.",
//       gradient: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
//       stats: "2-Year Coverage"
//     },
//     {
//       icon: <Phone className="w-12 h-12" />,
//       label: "CONNECTIVITY",
//       title: "All Networks Available",
//       description: "Choose from all major carriers. Get the best deals and plans.",
//       gradient: `linear-gradient(135deg, ${colors.accent}, #EC4899)`,
//       stats: "3 Networks"
//     },
//     {
//       icon: <Headphones className="w-12 h-12" />,
//       label: "SUPPORT",
//       title: "24/7 Expert Assistance",
//       description: "From setup to troubleshooting, we're here to help anytime.",
//       gradient: `linear-gradient(135deg, #F59E0B, #EF4444)`,
//       stats: "Always Online"
//     },
//     {
//       icon: <RefreshCw className="w-12 h-12" />,
//       label: "TRADE-IN",
//       title: "Maximum Value Guaranteed",
//       description: "Trade in your old device and get instant cash back on new purchases.",
//       gradient: `linear-gradient(135deg, ${colors.success}, #059669)`,
//       stats: "Up to ₦15,000"
//     }
//   ];

//   const features = [
//     { icon: <Truck />, title: "Free Delivery", desc: "On orders over R500" },
//     { icon: <Shield />, title: "Secure Payment", desc: "100% protected" },
//     { icon: <Award />, title: "Official Warranty", desc: "All products covered" },
//     { icon: <Zap />, title: "Same Day Setup", desc: "Ready to use" }
//   ];

//   const handleAddToCart = async (e, product) => {
//   await addToCart(e, product, fetchUserAddToCart);
// };

//   const handleProductsViews = ()=>{
//     navigate('/')
//   }


//   const handleProductsSearch = ()=>{
//     navigate('/product-category')
//   }


//   const renderStars = (rating) => {
//   return [...Array(5)].map((_, i) => (
//     <Star
//       key={i}
//       size={12}
//       fill={i < Math.floor(rating) ? colors.primary : i < rating ? colors.primary : colors.border}
//       style={{ color: i < Math.floor(rating) ? colors.primary : i < rating ? colors.primary : colors.border }}
//     />
//   ));
// }

//   return (
//     <div className="min-h-screen bg-white overflow-hidden relative">
//       {/* Animated Background Elements */}
//       <div className="fixed inset-0 pointer-events-none overflow-hidden">
//         <motion.div
//           className="absolute w-96 h-96 rounded-full blur-3xl opacity-20"
//           style={{
//             background: `radial-gradient(circle, ${colors.primary}, transparent)`,
//             x: useTransform(scrollYProgress, [0, 1], [0, 100]),
//             y: useTransform(scrollYProgress, [0, 1], [0, -100])
//           }}
//         />
//         <motion.div
//           className="absolute right-0 bottom-0 w-96 h-96 rounded-full blur-3xl opacity-20"
//           style={{
//             background: `radial-gradient(circle, ${colors.accent}, transparent)`,
//             x: useTransform(scrollYProgress, [0, 1], [0, -100]),
//             y: useTransform(scrollYProgress, [0, 1], [0, 100])
//           }}
//         />
//       </div>

//       {/* Progress Bar */}
//       <motion.div
//         className="fixed top-0 left-0 right-0 h-1 z-50 origin-left"
//         style={{
//           scaleX: scaleProgress,
//           background: `linear-gradient(90deg, ${colors.primary}, ${colors.accent})`
//         }}
//       />

//       {/* Navigation */}
//       <motion.nav
//         initial={{ y: -100 }}
//         animate={{ y: 0 }}
//         transition={{ duration: 0.6, ease: 'easeOut' }}
//         className={`fixed top-0 w-full z-40 transition-all duration-500 ${
//           scrolled ? 'bg-white/80 backdrop-blur-2xl shadow-xl' : 'bg-transparent'
//         }`}
//         style={{ borderBottom: scrolled ? `1px solid ${colors.border}` : 'none' }}
//       >
//         <div className="max-w-[1400px] mx-auto px-6">
//           <div className="flex justify-between items-center h-16">
//             {/* Logo */}
//             <motion.div
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               className="flex items-center gap-3"
//             >
//               <motion.div
//                 animate={{
//                   rotate: [0, 360],
//                   scale: [1, 1.1, 1]
//                 }}
//                 transition={{
//                   rotate: { duration: 20, repeat: Infinity, ease: 'linear' },
//                   scale: { duration: 2, repeat: Infinity, ease: 'easeInOut' }
//                 }}
//                 className="w-10 h-10 rounded-xl flex items-center justify-center text-white relative"
//                 style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})` }}
//               >
//                 <ShoppingBag className="w-6 h-6" />
//                 <motion.div
//                   className="absolute inset-0 rounded-xl"
//                   animate={{
//                     boxShadow: [
//                       `0 0 20px ${colors.primary}50`,
//                       `0 0 40px ${colors.accent}50`,
//                       `0 0 20px ${colors.primary}50`
//                     ]
//                   }}
//                   transition={{ duration: 3, repeat: Infinity }}
//                 />
//               </motion.div>
//               <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
//                 JosiePhones
//               </span>
//             </motion.div>

//             {/* Center Nav */}
//             <div className="hidden lg:flex items-center gap-8">
//               {['iPhone', 'iPad', 'Mac', 'Watch', 'AirPods', 'Accessories'].map((item, i) => (
//                 <motion.a
//                   key={item}
//                   href="#"
//                   initial={{ opacity: 0, y: -20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ delay: i * 0.1 }}
//                   whileHover={{ y: -2 }}
//                   className="text-sm font-medium relative group"
//                   style={{ color: colors.text }}
//                 >
//                   {item}
//                   <motion.div
//                     className="absolute -bottom-1 left-0 h-0.5 bg-gradient-to-r from-blue-600 to-purple-600"
//                     initial={{ width: 0 }}
//                     whileHover={{ width: '100%' }}
//                     transition={{ duration: 0.3 }}
//                   />
//                 </motion.a>
//               ))}
//             </div>

//             {/* Right Actions */}
//             <div className="flex items-center gap-4">
//               <motion.button
//                 whileHover={{ scale: 1.1, rotate: 90 }}
//                 whileTap={{ scale: 0.9 }}
//                 className="p-2 rounded-xl transition-all"
//                 style={{ backgroundColor: colors.bgTertiary, color: colors.primary }}
//               >
//                 <Search className="w-5 h-5" />
//               </motion.button>
//               <motion.button
//                 whileHover={{ scale: 1.1 }}
//                 whileTap={{ scale: 0.9 }}
//                 className="p-2 rounded-xl transition-all relative"
//                 style={{ backgroundColor: colors.bgTertiary, color: colors.accent }}
//               >
//                 <Heart className="w-5 h-5" />
//                 <motion.span
//                   animate={{ scale: [1, 1.2, 1] }}
//                   transition={{ duration: 2, repeat: Infinity }}
//                   className="absolute -top-1 -right-1 w-5 h-5 rounded-full text-xs font-bold flex items-center justify-center text-white"
//                   style={{ backgroundColor: colors.accent }}
//                 >
//                   3
//                 </motion.span>
//               </motion.button>
//               <motion.button
//                 whileHover={{ scale: 1.1 }}
//                 whileTap={{ scale: 0.9 }}
//                 className="p-2 rounded-xl transition-all relative"
//                 style={{ backgroundColor: colors.bgTertiary, color: colors.primary }}
//               >
//                 <ShoppingCart className="w-5 h-5" />
//                 <motion.span
//                   animate={{ scale: [1, 1.2, 1] }}
//                   transition={{ duration: 2, repeat: Infinity, delay: 0.5 }}
//                   className="absolute -top-1 -right-1 w-5 h-5 rounded-full text-xs font-bold flex items-center justify-center text-white"
//                   style={{ backgroundColor: colors.primary }}
//                 >
//                   5
//                 </motion.span>
//               </motion.button>
//             </div>
//           </div>
//         </div>
//       </motion.nav>

//       {/* Hero Section */}
//       <section ref={heroRef} className="relative pt-24 pb-20 min-h-screen flex items-center overflow-hidden">
//         {/* Animated grid background */}
//         <div className="absolute inset-0 opacity-5">
//           <div className="absolute inset-0" style={{
//             backgroundImage: `linear-gradient(${colors.primary} 1px, transparent 1px), linear-gradient(90deg, ${colors.primary} 1px, transparent 1px)`,
//             backgroundSize: '50px 50px'
//           }} />
//         </div>

//         <div className="max-w-[1400px] mx-auto px-6 relative z-10 w-full">
//           <div className="grid lg:grid-cols-2 gap-16 items-center">
//             {/* Hero Content */}
//             <motion.div
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               transition={{ duration: 1 }}
//             >
//               <motion.div
//                 initial={{ scale: 0 }}
//                 animate={{ scale: 1 }}
//                 transition={{ duration: 0.6, type: 'spring' }}
//                 className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6"
//                 style={{ backgroundColor: `${colors.primary}15` }}
//               >
//                 <Sparkles className="w-4 h-4" style={{ color: colors.primary }} />
//                 <span className="text-sm font-bold" style={{ color: colors.primary }}>
//                   New Arrivals Available Now
//                 </span>
//               </motion.div>

//               <h1 className="text-6xl lg:text-7xl font-black mb-6 leading-tight">
//                 <div className="overflow-hidden">
//                   <motion.span
//                     className="hero-title-word inline-block"
//                     style={{ 
//                       background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
//                       WebkitBackgroundClip: 'text',
//                       WebkitTextFillColor: 'transparent'
//                     }}
//                   >
//                     Discover
//                   </motion.span>
//                 </div>
//                 <div className="overflow-hidden">
//                   <motion.span className="hero-title-word inline-block text-gray-900">
//                     The Future
//                   </motion.span>
//                 </div>
//                 <div className="overflow-hidden">
//                   <motion.span className="hero-title-word inline-block text-gray-900">
//                     of Technology
//                   </motion.span>
//                 </div>
//               </h1>

//               <motion.p
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.5, duration: 0.8 }}
//                 className="text-xl mb-8 leading-relaxed"
//                 style={{ color: colors.textSecondary }}
//               >
//                 Experience innovation with our premium collection of cutting-edge devices. 
//                 Buy it easily at JosiePhones!
//               </motion.p>

//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.7, duration: 0.8 }}
//                 className="flex flex-wrap gap-4"
//               >
//                 <motion.button
//                   whileHover={{ scale: 1.05, boxShadow: `0 20px 40px ${colors.primary}30` }}
//                   whileTap={{ scale: 0.95 }}
//                   className="px-8 py-4 rounded-2xl font-bold text-white flex items-center gap-2 relative overflow-hidden group"
//                   style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})` }}
//                   onClick={handleProductsSearch}
//                 >
//                   <span 
//                     className="relative z-10"
                    
//                   >
//                     Shop Now
//                   </span>
//                   <ArrowRight className="w-5 h-5 relative z-10 group-hover:translate-x-1 transition-transform" />
//                   <motion.div
//                     className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20"
//                     initial={{ x: '-100%' }}
//                     whileHover={{ x: '100%' }}
//                     transition={{ duration: 0.6 }}
//                   />
//                 </motion.button>

//                 <motion.button
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                   className="px-8 py-4 rounded-2xl font-bold border-2 flex items-center gap-2"
//                   style={{ 
//                     borderColor: colors.primary,
//                     color: colors.primary
//                   }}
//                 >
//                   <Sparkles className="w-5 h-5" />
//                   Explore Products
//                 </motion.button>
//               </motion.div>

//               {/* Stats */}
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.9, duration: 0.8 }}
//                 className="grid grid-cols-3 gap-6 mt-12"
//               >
//                 {[
//                   { value: '50K+', label: 'Happy Customers' },
//                   { value: '1000+', label: 'Products' },
//                   { value: '4.9', label: 'Rating' }
//                 ].map((stat, i) => (
//                   <motion.div
//                     key={i}
//                     whileHover={{ y: -5 }}
//                     className="text-center"
//                   >
//                     <motion.div
//                       initial={{ scale: 0 }}
//                       animate={{ scale: 1 }}
//                       transition={{ delay: 1 + i * 0.1, type: 'spring' }}
//                       className="text-3xl font-black mb-1"
//                       style={{ 
//                         background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
//                         WebkitBackgroundClip: 'text',
//                         WebkitTextFillColor: 'transparent'
//                       }}
//                     >
//                       {stat.value}
//                     </motion.div>
//                     <div className="text-sm" style={{ color: colors.textSecondary }}>
//                       {stat.label}
//                     </div>
//                   </motion.div>
//                 ))}
//               </motion.div>
//             </motion.div>

//             {/* Hero Images - 3D Stack */}
//             <div className="relative h-[600px]">
//               {heroProducts.map((product, i) => (
//                 <motion.div
//                   key={product.id}
//                   className="floating-element absolute parallax-img"
//                   initial={{ opacity: 0, scale: 0, rotateY: 180 }}
//                   animate={{ 
//                     opacity: 1, 
//                     scale: 1, 
//                     rotateY: 0,
//                     x: [0, i * 20, 0],
//                     y: [0, -i * 15, 0]
//                   }}
//                   transition={{ 
//                     delay: 0.2 * i, 
//                     duration: 1,
//                     x: { duration: 3, repeat: Infinity, ease: 'easeInOut' },
//                     y: { duration: 2.5, repeat: Infinity, ease: 'easeInOut', delay: i * 0.2 }
//                   }}
//                   whileHover={{ 
//                     scale: 1.1, 
//                     zIndex: 50,
//                     rotateY: 10,
//                     transition: { duration: 0.3 }
//                   }}
//                   style={{
//                     top: `${i * 80}px`,
//                     left: `${i * 60}px`,
//                     zIndex: 10 - i
//                   }}
//                   // className="w-80 h-96 rounded-3xl overflow-hidden cursor-pointer group"
//                 >
//                   <div className="relative w-full h-full">
//                     <img
//                       src={product.image}
//                       alt={product.name}
//                       className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
//                     />
//                     <div 
//                       className="absolute inset-0 opacity-80 group-hover:opacity-90 transition-opacity"
//                       style={{ background: `linear-gradient(135deg, transparent, ${product.color.split(' ')[1]} 100%)` }}
//                     />
//                     <div className="absolute inset-0 p-6 flex flex-col justify-end text-white">
//                       <motion.span
//                         initial={{ scale: 0 }}
//                         animate={{ scale: 1 }}
//                         className="inline-block px-3 py-1 rounded-full text-xs font-bold mb-3 w-fit"
//                         style={{ backgroundColor: 'rgba(255,255,255,0.3)', backdropFilter: 'blur(10px)' }}
//                       >
//                         {product.badge}
//                       </motion.span>
//                       <h3 className="text-2xl font-bold mb-2">{product.name}</h3>
//                       <p className="text-sm opacity-90 mb-2">{product.tagline}</p>
//                       <p className="text-3xl font-black">{product.price}</p>
//                     </div>
//                   </div>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Scroll Indicator */}
//         <motion.div
//           animate={{ y: [0, 10, 0] }}
//           transition={{ duration: 2, repeat: Infinity }}
//           className="absolute bottom-10 left-1/2 transform -translate-x-1/2"
//         >
//           <ChevronRight className="w-6 h-6 rotate-90" style={{ color: colors.primary }} />
//         </motion.div>
//       </section>

//       {/* Features Bar */}
//       <section className="py-8" style={{ backgroundColor: colors.bgSecondary }}>
//         <div className="max-w-[1400px] mx-auto px-6">
//           <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
//             {features.map((feature, i) => (
//               <motion.div
//                 key={i}
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: i * 0.1 }}
//                 whileHover={{ y: -5 }}
//                 className="flex items-center gap-3 p-4 rounded-2xl"
//                 style={{ backgroundColor: colors.bg }}
//               >
//                 <div 
//                   className="p-3 rounded-xl"
//                   style={{ backgroundColor: `${colors.primary}15`, color: colors.primary }}
//                 >
//                   {feature.icon}
//                 </div>
//                 <div>
//                   <div className="font-bold text-sm" style={{ color: colors.text }}>
//                     {feature.title}
//                   </div>
//                   <div className="text-xs" style={{ color: colors.textSecondary }}>
//                     {feature.desc}
//                   </div>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Featured Products */}
// <section ref={productsRef} className="py-24">
//   <div className="max-w-[1400px] mx-auto px-6">
//     <motion.div
//       initial={{ opacity: 0, y: 30 }}
//       whileInView={{ opacity: 1, y: 0 }}
//       viewport={{ once: true }}
//       className="text-center mb-16"
//     >
//       <motion.div
//         initial={{ scale: 0 }}
//         whileInView={{ scale: 1 }}
//         viewport={{ once: true }}
//         className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-4"
//         style={{ backgroundColor: `${colors.accent}15` }}
//       >
//         <Star className="w-4 h-4" style={{ color: colors.accent }} />
//         <span className="text-sm font-bold" style={{ color: colors.accent }}>
//           Trending Now
//         </span>
//       </motion.div>
//       <h2 className="text-5xl font-black mb-4" style={{ color: colors.text }}>
//         Featured Products
//       </h2>
//       <p className="text-xl max-w-2xl mx-auto" style={{ color: colors.textSecondary }}>
//         Discover our handpicked selection of premium devices
//       </p>
//     </motion.div>

//     {/* Loading State */}
//     {loadingProducts && (
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
//         {Array.from({ length: 6 }).map((_, i) => (
//           <div
//             key={i}
//             className="rounded-3xl overflow-hidden animate-pulse"
//             style={{ backgroundColor: colors.bgSecondary }}
//           >
//             <div className="h-80" style={{ backgroundColor: colors.bgTertiary }} />
//             <div className="p-6 space-y-4">
//               <div className="h-4 rounded-full w-3/4" style={{ backgroundColor: colors.bgTertiary }} />
//               <div className="h-6 rounded-full w-1/2" style={{ backgroundColor: colors.bgTertiary }} />
//               <div className="h-8 rounded-full w-2/3" style={{ backgroundColor: colors.bgTertiary }} />
//             </div>
//           </div>
//         ))}
//       </div>
//     )}

//     {/* Featured Products Grid */}
// {!loadingProducts && (
//   <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
//     {featuredProducts.slice(0, 6).map((product, i) => (
//       <motion.div
//         key={product._id}
//         className="product-reveal group cursor-pointer"
//         whileHover={{ y: -10 }}
//         transition={{ type: 'spring', stiffness: 300 }}
//       >
//         <div className="relative rounded-3xl overflow-hidden" style={{ backgroundColor: colors.bgSecondary }}>
//           {/* Product Image */}
//           <div className="relative h-80 overflow-hidden">
//             <motion.img
//               src={product.productImage?.[0]}
//               alt={product.productName}
//               className="w-full h-full object-cover"
//               whileHover={{ scale: 1.15, rotate: 2 }}
//               transition={{ duration: 0.6 }}
//             />
//             <motion.div
//               className="absolute inset-0"
//               initial={{ opacity: 0 }}
//               whileHover={{ opacity: 1 }}
//               style={{ background: `linear-gradient(135deg, transparent, ${colors.primary}40)` }}
//             />
            
//             {/* Badge - Use featured status */}
//             {product.featured && (
//               <motion.div
//                 initial={{ scale: 0, rotate: -180 }}
//                 animate={{ scale: 1, rotate: 0 }}
//                 transition={{ delay: i * 0.1 + 0.3 }}
//                 className="absolute top-4 right-4 px-3 py-1 rounded-full text-xs font-bold text-white"
//                 style={{ backgroundColor: colors.accent }}
//               >
//                 FEATURED
//               </motion.div>
//             )}

//             {/* Discount Badge */}
//             {product.productDiscount && product.productPrice && (
//               <motion.div
//                 initial={{ scale: 0, rotate: -180 }}
//                 animate={{ scale: 1, rotate: 0 }}
//                 transition={{ delay: i * 0.1 + 0.3 }}
//                 className="absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-bold text-white"
//                 style={{ backgroundColor: colors.accent }}
//               >
//                 -{Math.round((product.productDiscount / product.productPrice) * 100)}%
//               </motion.div>
//             )}

//             {/* REAL Like Button (replacing the heart icon) */}
//             <div className="absolute bottom-4 left-4 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20 pointer-events-auto">
//               <LikeButton productId={product._id} size={20} />
//             </div>

//             {/* Hover Overlay with View Details Button */}
//             <motion.div
//               className="absolute inset-0 flex items-center justify-center"
//               initial={{ opacity: 0 }}
//               whileHover={{ opacity: 1 }}
//               style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}
//             >
//               <motion.button
//                 initial={{ y: 20 }}
//                 whileHover={{ y: 0 }}
//                 className="px-6 py-3 rounded-full font-bold text-white flex items-center gap-2"
//                 style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})` }}
//                 onClick={() => navigate(`/product/${product._id}`)}
//               >
//                 <Eye size={16} />
//                 View Details
//               </motion.button>
//             </motion.div>
//           </div>

//           {/* Product Info */}
//           <div className="p-6">
//             <div className="flex items-center justify-between mb-3">
//               <span className="text-sm font-bold" style={{ color: colors.primary }}>
//                 {product.productsCategory}
//               </span>
              
//               {/* REAL Rating Section */}
//               <div className="flex items-center gap-1">
//                 <div className="flex gap-0.5">
//                   {productRatings[product._id] ? (
//                     renderStars(productRatings[product._id].average)
//                   ) : (
//                     [...Array(5)].map((_, i) => (
//                       <Star key={i} size={12} style={{ color: colors.border }} />
//                     ))
//                   )}
//                 </div>
//                 <span className="text-xs ml-1" style={{ color: colors.textSecondary }}>
//                   {productRatings[product._id] ? (
//                     `(${productRatings[product._id].average.toFixed(1)})`
//                   ) : (
//                     '(No reviews)'
//                   )}
//                 </span>
//               </div>
//             </div>
            
//             <h3 className="text-xl font-bold mb-3" style={{ color: colors.text }}>
//               {product.productName}
//             </h3>

//             <div className="flex items-center justify-between">
//               <div>
//                 <div className="text-3xl font-black" style={{ color: colors.text }}>
//                   ₦{product.productPrice?.toLocaleString()}
//                 </div>
//                 {/* {product.productDiscount > 0 && (
//                   <div className="text-sm line-through" style={{ color: colors.textSecondary }}>
//                     ₦{(parseFloat(product.productPrice) + parseFloat(product.productDiscount)).toLocaleString()}
//                   </div>
//                 )} */}
//               </div>
              
//               {/* Add to Cart Button */}
//               <motion.button
//                 whileHover={{ scale: 1.1, rotate: 360 }}
//                 whileTap={{ scale: 0.9 }}
//                 transition={{ rotate: { duration: 0.5 } }}
//                 className="w-12 h-12 rounded-full flex items-center justify-center text-white"
//                 style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})` }}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleAddToCart(e, product);
//                 }}
//               >
//                 <ShoppingCart className="w-5 h-5" />
//               </motion.button>
//             </div>
//           </div>
//         </div>
//       </motion.div>
//     ))}
//   </div>
// )}

//     {/* Empty State */}
//     {!loadingProducts && featuredProducts.length === 0 && (
//       <div className="text-center py-12">
//         <Package className="w-16 h-16 mx-auto mb-4" style={{ color: colors.textSecondary }} />
//         <p className="text-xl" style={{ color: colors.textSecondary }}>No featured products available</p>
//       </div>
//     )}

//     {/* View All Button */}
//     <motion.div
//       initial={{ opacity: 0, scale: 0.8 }}
//       whileInView={{ opacity: 1, scale: 1 }}
//       viewport={{ once: true }}
//       className="text-center mt-12"
//     >
//       <motion.button
//         whileHover={{ scale: 1.05, boxShadow: `0 20px 40px ${colors.primary}30` }}
//         whileTap={{ scale: 0.95 }}
//         className="px-10 py-4 rounded-2xl font-bold text-white flex items-center gap-2 mx-auto"
//         style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})` }}
//         onClick={handleProductsViews}
//       >
//         View All Products
//         <TrendingUp className="w-5 h-5" />
//       </motion.button>
//     </motion.div>
//   </div>
// </section>

//       {/* Services Section */}
//       <section ref={servicesRef} className="py-24" style={{ backgroundColor: colors.bgSecondary }}>
//         <div className="max-w-[1400px] mx-auto px-6">
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="text-center mb-16"
//           >
//             <motion.div
//               initial={{ scale: 0 }}
//               whileInView={{ scale: 1 }}
//               viewport={{ once: true }}
//               className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-4"
//               style={{ backgroundColor: `${colors.success}15` }}
//             >
//               <CheckCircle2 className="w-4 h-4" style={{ color: colors.success }} />
//               <span className="text-sm font-bold" style={{ color: colors.success }}>
//                 Premium Services
//               </span>
//             </motion.div>
//             <h2 className="text-5xl font-black mb-4" style={{ color: colors.text }}>
//               Why Shop With Us
//             </h2>
//             <p className="text-xl max-w-2xl mx-auto" style={{ color: colors.textSecondary }}>
//               Experience unmatched service and support at every step
//             </p>
//           </motion.div>

//           <div className="grid md:grid-cols-2 gap-6">
//             {services.map((service, i) => (
//               <motion.div
//                 key={i}
//                 className="service-card group cursor-pointer"
//                 whileHover={{ scale: 1.02 }}
//                 transition={{ type: 'spring', stiffness: 300 }}
//               >
//                 <div 
//                   className="rounded-3xl p-8 md:p-10 min-h-[350px] flex flex-col justify-between text-white relative overflow-hidden"
//                   style={{ background: service.gradient }}
//                 >
//                   {/* Animated background circles */}
//                   <motion.div
//                     className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-white/10"
//                     animate={{
//                       scale: [1, 1.2, 1],
//                       rotate: [0, 180, 360]
//                     }}
//                     transition={{ duration: 20, repeat: Infinity }}
//                   />
//                   <motion.div
//                     className="absolute -left-10 -bottom-10 w-32 h-32 rounded-full bg-white/10"
//                     animate={{
//                       scale: [1, 1.3, 1],
//                       rotate: [0, -180, -360]
//                     }}
//                     transition={{ duration: 15, repeat: Infinity }}
//                   />

//                   <div className="relative z-10">
//                     <motion.div
//                       whileHover={{ rotate: 360, scale: 1.2 }}
//                       transition={{ duration: 0.6 }}
//                       className="mb-6 inline-block"
//                     >
//                       {service.icon}
//                     </motion.div>
                    
//                     <div className="text-xs font-bold tracking-wider mb-3 opacity-90">
//                       {service.label}
//                     </div>
                    
//                     <h3 className="text-3xl font-black mb-3 leading-tight">
//                       {service.title}
//                     </h3>
                    
//                     <p className="text-base opacity-90 leading-relaxed mb-4">
//                       {service.description}
//                     </p>

//                     <motion.div
//                       initial={{ width: 0 }}
//                       whileInView={{ width: '80px' }}
//                       viewport={{ once: true }}
//                       transition={{ delay: i * 0.2 }}
//                       className="h-1 bg-white rounded-full mb-4"
//                     />

//                     <div className="text-2xl font-black">
//                       {service.stats}
//                     </div>
//                   </div>

//                   <motion.button
//                     whileHover={{ x: 10 }}
//                     className="relative z-10 text-white font-bold flex items-center gap-2 mt-6 group-hover:gap-4 transition-all"
//                   >
//                     Learn More
//                     <ArrowRight className="w-5 h-5" />
//                   </motion.button>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Testimonials Section */}
//       <section className="py-24">
//         <div className="max-w-[1400px] mx-auto px-6">
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="text-center mb-16"
//           >
//             <h2 className="text-5xl font-black mb-4" style={{ color: colors.text }}>
//               What Our Customers Say
//             </h2>
//             <p className="text-xl" style={{ color: colors.textSecondary }}>
//               Join thousands of satisfied customers
//             </p>
//           </motion.div>

//           <div className="grid md:grid-cols-3 gap-6">
//             {[1, 2, 3].map((item, i) => (
//               <motion.div
//                 key={i}
//                 initial={{ opacity: 0, y: 50 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: i * 0.2 }}
//                 whileHover={{ y: -10, boxShadow: `0 20px 40px ${colors.primary}20` }}
//                 className="p-8 rounded-3xl relative"
//                 style={{ backgroundColor: colors.bg, border: `1px solid ${colors.border}` }}
//               >
//                 <div className="flex gap-1 mb-4">
//                   {[1, 2, 3, 4, 5].map((star) => (
//                     <motion.div
//                       key={star}
//                       initial={{ scale: 0, rotate: -180 }}
//                       whileInView={{ scale: 1, rotate: 0 }}
//                       viewport={{ once: true }}
//                       transition={{ delay: i * 0.2 + star * 0.1 }}
//                     >
//                       <Star className="w-5 h-5 fill-current" style={{ color: colors.warning }} />
//                     </motion.div>
//                   ))}
//                 </div>
                
//                 <p className="text-lg mb-6 leading-relaxed" style={{ color: colors.text }}>
//                   "Absolutely amazing experience! The quality and service exceeded all expectations. Highly recommend!"
//                 </p>

//                 <div className="flex items-center gap-3">
//                   <motion.div
//                     whileHover={{ scale: 1.1, rotate: 360 }}
//                     transition={{ duration: 0.6 }}
//                     className="w-12 h-12 rounded-full flex items-center justify-center text-white font-bold"
//                     style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})` }}
//                   >
//                     {String.fromCharCode(65 + i)}
//                   </motion.div>
//                   <div>
//                     <div className="font-bold" style={{ color: colors.text }}>
//                       Customer {i + 1}
//                     </div>
//                     <div className="text-sm" style={{ color: colors.textSecondary }}>
//                       Verified Buyer
//                     </div>
//                   </div>
//                 </div>

//                 <motion.div
//                   className="absolute top-6 right-6 opacity-10"
//                   animate={{ rotate: 360 }}
//                   transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
//                 >
//                   <Gift className="w-16 h-16" style={{ color: colors.primary }} />
//                 </motion.div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="py-24 relative overflow-hidden">
//         <motion.div
//           className="absolute inset-0"
//           style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})` }}
//         />
        
//         {/* Animated background elements */}
//         <motion.div
//           className="absolute top-0 left-0 w-64 h-64 rounded-full bg-white/10"
//           animate={{
//             scale: [1, 1.5, 1],
//             x: [0, 100, 0],
//             y: [0, 50, 0]
//           }}
//           transition={{ duration: 10, repeat: Infinity }}
//         />
//         <motion.div
//           className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-white/10"
//           animate={{
//             scale: [1, 1.3, 1],
//             x: [0, -100, 0],
//             y: [0, -50, 0]
//           }}
//           transition={{ duration: 15, repeat: Infinity }}
//         />

//         <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
//           <motion.div
//             initial={{ opacity: 0, scale: 0.8 }}
//             whileInView={{ opacity: 1, scale: 1 }}
//             viewport={{ once: true }}
//             className="mb-8"
//           >
//             <motion.div
//               animate={{ rotate: 360 }}
//               transition={{ duration: 3, repeat: Infinity, ease: 'linear' }}
//               className="w-20 h-20 mx-auto mb-6 rounded-full bg-white/20 flex items-center justify-center"
//             >
//               <Sparkles className="w-10 h-10 text-white" />
//             </motion.div>

//             <h2 className="text-5xl md:text-6xl font-black text-white mb-6">
//               Ready to Upgrade?
//             </h2>
//             <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed">
//               Join thousands of satisfied customers and experience the future of technology today with JosiePhones!
//             </p>
//           </motion.div>

//           <div className="flex flex-col sm:flex-row gap-4 justify-center">
//             <motion.button
//               whileHover={{ scale: 1.05, y: -5 }}
//               whileTap={{ scale: 0.95 }}
//               className="px-10 py-5 rounded-2xl font-bold bg-white flex items-center justify-center gap-2 shadow-2xl"
//               style={{ color: colors.primary }}
//             >
//               Start Shopping
//               <ShoppingBag className="w-5 h-5" />
//             </motion.button>
            
//             <motion.button
//               whileHover={{ scale: 1.05, y: -5 }}
//               whileTap={{ scale: 0.95 }}
//               className="px-10 py-5 rounded-2xl font-bold border-2 border-white text-white hover:bg-white/10 transition-colors"
//             >
//               Contact Us
//             </motion.button>
//           </div>

//           {/* Trust badges */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="mt-12 flex flex-wrap justify-center gap-6"
//           >
//             {['Secure Payment', 'Free Delivery', '2-Year Warranty', '24/7 Support'].map((badge, i) => (
//               <motion.div
//                 key={i}
//                 initial={{ opacity: 0, scale: 0 }}
//                 whileInView={{ opacity: 1, scale: 1 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: i * 0.1 }}
//                 className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm"
//               >
//                 <CheckCircle2 className="w-4 h-4 text-white" />
//                 <span className="text-sm text-white font-medium">{badge}</span>
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>
//       </section>
     
//     </div>
//   );
// };

// export default LandingPage;

// import React, { useState, useEffect, useMemo } from 'react';
// import CategoryList from '../../components/CategoryList/CategoryList';
// import BannerProduct from '../../components/BannerProduct/BannerProduct';
// import HorizontalCardProduct from '../../components/HorizontalCardProduct/HorizontalCardProduct';
// import VerticalCardProduct from '../../components/VerticalCardProduct/VerticalCardProduct';
// import NewsletterBox from '../../components/NewsletterBox/NewsletterBox';
// import { useTheme } from '../../components/Theme/ThemeProvider';
// import { useNavigate } from 'react-router-dom';
// import { ArrowLeft } from 'lucide-react';
// import FeaturedDealsBanner from 'components/Deals/FeaturedDealsBanner';

// function LandingPage() {
//     const { colors } = useTheme();
//     const navigate = useNavigate();
//     const [visibleSections, setVisibleSections] = useState({
//         banner: true,
//         smartphones: false,
//         tablets: false,
//         laptops: false,
//         smartwatches: false,
//         drones: false,
//         accessories: false,
//         games: false,
//         newsletter: false
//     });

//     useEffect(() => {
//         // Load first sections immediately
//         setVisibleSections(prev => ({
//             ...prev,
//             smartphones: true,
//             laptops: true
//         }));

//         // Lazy load the rest
//         const timer = setTimeout(() => {
//             setVisibleSections(prev => ({
//                 ...prev,
//                 tablets: true,
//                 smartwatches: true,
//                 drones: true,
//                 accessories: true,
//                 games: true,
//                 newsletter: true
//             }));
//         }, 300);

//         return () => clearTimeout(timer);
//     }, []);

//     // Section skeleton loader
//     const SectionSkeleton = () => (
//         <div className="space-y-4">
//             <div className="h-8 bg-slate-200 dark:bg-slate-800 rounded w-1/3 animate-pulse"></div>
//             <div className="flex gap-4 overflow-hidden">
//                 {[...Array(4)].map((_, i) => (
//                     <div key={i} className="min-w-[280px] h-48 bg-slate-200 dark:bg-slate-800 rounded-lg animate-pulse"></div>
//                 ))}
//             </div>
//         </div>
//     );

//     // Product section wrapper
//     const ProductSection = ({ 
//         id, 
//         title, 
//         emoji, 
//         description, 
//         component: Component, 
//         props, 
//         isVisible 
//     }) => (
//         <section 
//             id={`section-${id}`}
//             className="mb-12 transition-opacity duration-500"
//             style={{ backgroundColor: colors.bg }}
//         >
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                 {/* Section Header */}
//                 <div className="mb-8">
//                     <div className="flex items-center gap-3 mb-3">
//                         <h2 
//                             className="text-3xl md:text-4xl font-black"
//                             style={{ color: colors.text }}
//                         >
//                             <span className="mr-3">{emoji}</span>
//                             {title}
//                         </h2>
//                     </div>
//                     <p 
//                         className="text-lg"
//                         style={{ color: colors.textSecondary }}
//                     >
//                         {description}
//                     </p>
//                     <div 
//                         className="h-1 w-20 mt-4 rounded-full"
//                         style={{ backgroundColor: colors.primary }}
//                     />
//                 </div>

//                 {/* Content */}
//                 {isVisible ? (
//                     <div className="animate-fadeIn">
//                         <Component {...props} />
//                     </div>
//                 ) : (
//                     <SectionSkeleton />
//                 )}
//             </div>
//         </section>
//     );

//     const goBack = ()=>{
//         navigate("/landing");
//     }

//     return (
//         <div 
//             style={{ 
//                 backgroundColor: colors.bg, 
//                 minHeight: '100vh',
//                 transition: 'background-color 0.3s ease'
//             }}
//         >
                      
//             {/* Hero Section */}
//             <section
//                 className="relative overflow-hidden pt-24 pb-16 md:pt-32 md:pb-24"
//                 style={{
//                     background: `linear-gradient(135deg, ${colors.primaryLight} 0%, ${colors.accentLight} 100%)`
//                 }}
//             >
//                 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                     <button onClick={goBack} className="mb-8 text-white font-semibold underline">
//                     <ArrowLeft className="inline-block w-4 h-4 ml-1" /> Go Back 
//                     </button>
//                     <div className="text-center">
//                         <h1
//                             className="text-5xl md:text-6xl font-black mb-6 leading-tight"
//                             style={{ color: colors.text }}
//                         >
//                             Discover Your <span style={{ color: colors.primary }}>Next</span> Favorite
//                         </h1>
//                         <p
//                             className="text-xl md:text-2xl mb-8 max-w-2xl mx-auto"
//                             style={{ color: colors.textSecondary }}
//                         >
//                             Shop premium phones and gadgets with exclusive deals
//                         </p>
//                         <div 
//                             className="inline-block px-8 py-3 rounded-full font-bold text-white animate-pulse"
//                             style={{ backgroundColor: colors.primary }}
//                         >
//                             New Arrivals Added Daily
//                         </div>
//                     </div>
//                 </div>
//             </section>

//             {/* Category List - Always visible */}
//             <section 
//                 className="py-12"
//                 style={{ backgroundColor: colors.bgSecondary }}
//             >
//                 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                     <h2 
//                         className="text-3xl font-black mb-8"
//                         style={{ color: colors.text }}
//                     >
//                         Browse by Category
//                     </h2>
//                     <CategoryList />
//                 </div>
//             </section>

//             {/* Banner - Always visible */}
//             <section className="py-12" style={{ backgroundColor: colors.bg }}>
//                 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                     <BannerProduct />
//                 </div>
//             </section>

//             <div>
//             <FeaturedDealsBanner onViewAllDeals={() => navigate('/flashdeals')} />
//           </div>

//             {/* Lazy Loaded Product Sections */}
//             <div style={{ backgroundColor: colors.bg }}>
//                 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
//                     {/* Smartphones */}
//                     <ProductSection
//                         id="smartphones"
//                         title="Latest Smartphones"
//                         emoji="📱"
//                         description="Cutting-edge smartphones from top brands"
//                         component={HorizontalCardProduct}
//                         props={{
//                             productsCategory: "smartphones",
//                             heading: "Premium Smartphones"
//                         }}
//                         isVisible={visibleSections.smartphones}
//                     />

//                     {/* Laptops */}
//                     <ProductSection
//                         id="laptops"
//                         title="Powerful Laptops"
//                         emoji="💻"
//                         description="High-performance laptops for work and gaming"
//                         component={HorizontalCardProduct}
//                         props={{
//                             productsCategory: "laptops",
//                             heading: "Laptops & Notebooks"
//                         }}
//                         isVisible={visibleSections.laptops}
//                     />

//                     {/* Tablets */}
//                     <ProductSection
//                         id="tablets"
//                         title="Versatile Tablets"
//                         emoji="📟"
//                         description="Perfect blend of productivity and entertainment"
//                         component={VerticalCardProduct}
//                         props={{
//                             productsCategory: "tablets",
//                             heading: "Tablets & iPads"
//                         }}
//                         isVisible={visibleSections.tablets}
//                     />

//                     {/* Smart Watches */}
//                     <ProductSection
//                         id="smartwatches"
//                         title="Smart Watches"
//                         emoji="⌚"
//                         description="Stay connected and track your fitness"
//                         component={VerticalCardProduct}
//                         props={{
//                             productsCategory: "smart-watches",
//                             heading: "Smart Watches"
//                         }}
//                         isVisible={visibleSections.smartwatches}
//                     />

//                     {/* Drones */}
//                     <ProductSection
//                         id="drones"
//                         title="Professional Drones"
//                         emoji="🚁"
//                         description="Capture stunning aerial photography"
//                         component={VerticalCardProduct}
//                         props={{
//                             productsCategory: "drones",
//                             heading: "DJI Drones"
//                         }}
//                         isVisible={visibleSections.drones}
//                     />

//                     {/* Accessories */}
//                     <ProductSection
//                         id="accessories"
//                         title="Tech Accessories"
//                         emoji="🔌"
//                         description="Essential accessories for your devices"
//                         component={VerticalCardProduct}
//                         props={{
//                             productsCategory: "accessories",
//                             heading: "Chargers & Powerbanks"
//                         }}
//                         isVisible={visibleSections.accessories}
//                     />

//                     {/* Games Consoles */}
//                     <ProductSection
//                         id="games"
//                         title="Gaming Consoles"
//                         emoji="🎮"
//                         description="Next-gen gaming experience"
//                         component={VerticalCardProduct}
//                         props={{
//                             productsCategory: "games-consoles",
//                             heading: "Gaming & VR"
//                         }}
//                         isVisible={visibleSections.games}
//                     />
//                 </div>
//             </div>

//             {/* Newsletter */}
//             <section 
//                 id="section-newsletter"
//                 className="py-12"
//                 style={{ 
//                     background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.accent} 100%)`
//                 }}
//             >
//                 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                     {visibleSections.newsletter ? (
//                         <div className="animate-fadeIn">
//                             <NewsletterBox />
//                         </div>
//                     ) : (
//                         <div className="h-32 bg-white/10 rounded-lg animate-pulse"></div>
//                     )}
//                 </div>
//             </section>

//             <style jsx>{`
//                 @keyframes fadeIn {
//                     from {
//                         opacity: 0;
//                     }
//                     to {
//                         opacity: 1;
//                     }
//                 }

//                 .animate-fadeIn {
//                     animation: fadeIn 0.5s ease-out;
//                 }

//                 @keyframes pulse {
//                     0%, 100% {
//                         opacity: 1;
//                     }
//                     50% {
//                         opacity: 0.5;
//                     }
//                 }

//                 .animate-pulse {
//                     animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
//                 }
//             `}</style>
//         </div>
//     );
// }

// export default LandingPage;


import React, { useState, useEffect, useMemo } from 'react';
import CategoryList from '../../components/CategoryList/CategoryList';
import BannerProduct from '../../components/BannerProduct/BannerProduct';
import HorizontalCardProduct from '../../components/HorizontalCardProduct/HorizontalCardProduct';
import VerticalCardProduct from '../../components/VerticalCardProduct/VerticalCardProduct';
import NewsletterBox from '../../components/NewsletterBox/NewsletterBox';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ChevronRight, Star, TrendingUp, Clock, Shield, Truck, Sparkles } from 'lucide-react';
import FeaturedDealsBanner from '../../components/Deals/FeaturedDealsBanner';

function LandingPage() {
    const navigate = useNavigate();
    const [visibleSections, setVisibleSections] = useState({
        banner: true,
        smartphones: false,
        tablets: false,
        laptops: false,
        smartwatches: false,
        drones: false,
        accessories: false,
        games: false,
        newsletter: false
    });

    // Elegant color palette
    const colors = {
        primary: '#1a365d', // Elegant dark blue
        accent: '#7c3aed', // Elegant purple
        bg: '#fafafa', // Light background
        bgSecondary: '#ffffff', // White background
        bgTertiary: '#f5f5f5', // Light gray background
        text: '#171717', // Dark text
        textSecondary: '#525252', // Medium gray text
        border: '#d4d4d4', // Light border
        shadow: 'rgba(0, 0, 0, 0.05)',
        success: '#10b981'
    };

    useEffect(() => {
        // Load first sections immediately
        setVisibleSections(prev => ({
            ...prev,
            smartphones: true,
            laptops: true
        }));

        // Lazy load the rest
        const timer = setTimeout(() => {
            setVisibleSections(prev => ({
                ...prev,
                tablets: true,
                smartwatches: true,
                drones: true,
                accessories: true,
                games: true,
                newsletter: true
            }));
        }, 300);

        return () => clearTimeout(timer);
    }, []);

    // Section skeleton loader
    const SectionSkeleton = ({ isVertical = false }) => (
        <div className="space-y-4">
            <div className="h-6 sm:h-8 bg-neutral-200 rounded w-1/3 animate-pulse"></div>
            <div className={`flex ${isVertical ? 'flex-col sm:grid sm:grid-cols-2 lg:grid-cols-4' : 'gap-4 overflow-x-auto'} scrollbar-none`}>
                {[...Array(isVertical ? 4 : 4)].map((_, i) => (
                    <div 
                        key={i} 
                        className={`${isVertical ? 'mb-4 sm:mb-0' : 'min-w-[280px] sm:min-w-[300px]'} h-48 sm:h-56 bg-neutral-200 rounded-lg animate-pulse flex-shrink-0`}
                    ></div>
                ))}
            </div>
        </div>
    );

    // Product section wrapper
    const ProductSection = ({ 
        id, 
        title, 
        emoji, 
        description, 
        component: Component, 
        props, 
        isVisible,
        isVertical = false
    }) => (
        <section 
            id={`section-${id}`}
            className="py-6 sm:py-8 lg:py-12 transition-opacity duration-500 bg-white"
        >
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                {/* Section Header */}
                <div className="mb-6 sm:mb-8">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between sm:gap-4 mb-3 sm:mb-4">
                        <div>
                            <h2 
                                className="text-xl sm:text-2xl lg:text-3xl font-normal text-neutral-900 tracking-tight"
                                style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                            >
                                <span className="mr-2 sm:mr-3">{emoji}</span>
                                {title}
                            </h2>
                            <p 
                                className="text-sm sm:text-base text-neutral-600 mt-2"
                                style={{ fontFamily: 'Georgia, serif' }}
                            >
                                {description}
                            </p>
                        </div>
                        <button
                            onClick={() => navigate(`/category/${props.productsCategory}`)}
                            className="mt-3 sm:mt-0 flex items-center gap-1 sm:gap-2 text-xs sm:text-sm uppercase tracking-wider text-neutral-900 font-medium hover:opacity-70 transition-opacity"
                            style={{ fontFamily: 'Georgia, serif' }}
                        >
                            View All
                            <ChevronRight size={14} className='sm:w-4 sm:h-4' />
                        </button>
                    </div>
                    <div className="h-px w-12 sm:w-16 bg-neutral-300 mt-4" />
                </div>

                {/* Content */}
                {isVisible ? (
                    <div className="animate-fadeIn">
                        <Component {...props} />
                    </div>
                ) : (
                    <SectionSkeleton isVertical={isVertical} />
                )}
            </div>
        </section>
    );

    const goBack = () => {
        navigate(-1);
    }

    // Trust indicators for hero section
    const trustIndicators = [
        { icon: Shield, text: 'Secure Payments', color: 'text-neutral-900' },
        { icon: Truck, text: 'Free Shipping', color: 'text-emerald-700' },
        { icon: Clock, text: '24/7 Support', color: 'text-amber-600' },
        { icon: TrendingUp, text: 'Best Prices', color: 'text-blue-600' }
    ];

    return (
        <div className="min-h-screen mt-[-40px] bg-neutral-50" style={{ fontFamily: 'Georgia, serif' }}>
            {/* Hero Section */}
            <section className="relative overflow-hidden pt-16 sm:pt-20 lg:pt-24 pb-8 sm:pb-12 lg:pb-16 bg-white">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    {/* Back button - only show if on mobile and not first visit */}
                    <div className="mb-4 sm:mb-6">
                        <button 
                            onClick={goBack}
                            className="flex items-center gap-1 text-sm text-neutral-600 hover:text-neutral-900 transition-colors"
                            style={{ fontFamily: 'Georgia, serif' }}
                        >
                            <ArrowLeft className="w-4 h-4" />
                            <span className="hidden sm:inline">Back</span>
                        </button>
                    </div>

                    {/* Hero Content */}
                    <div className="text-center max-w-4xl mx-auto">
                        <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full border border-neutral-300 bg-neutral-100 mb-4 sm:mb-6">
                            <Sparkles className="w-3 h-3 sm:w-4 sm:h-4 text-neutral-600" />
                            <span className="text-xs sm:text-sm text-neutral-700 tracking-wide" 
                                  style={{ fontFamily: 'Georgia, serif' }}>
                                Premium Mobile Solutions
                            </span>
                        </div>

                        <h1
                            className="text-3xl sm:text-4xl lg:text-5xl font-normal text-neutral-900 mb-4 sm:mb-6 tracking-tight"
                            style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                        >
                            Discover Your <span className="text-neutral-900">Next</span> Favorite Device
                        </h1>
                        
                        <p
                            className="text-base sm:text-lg lg:text-xl text-neutral-600 mb-6 sm:mb-8 max-w-2xl mx-auto leading-relaxed"
                            style={{ fontFamily: 'Georgia, serif' }}
                        >
                            Shop premium smartphones, laptops, and cutting-edge gadgets with exclusive deals and expert service.
                        </p>

                        {/* Trust Indicators */}
                        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 max-w-2xl mx-auto mb-6 sm:mb-8">
                            {trustIndicators.map((item, index) => (
                                <div 
                                    key={index} 
                                    className="flex flex-col items-center p-3 sm:p-4 border border-neutral-300 rounded-lg bg-white"
                                >
                                    <item.icon className={`w-5 h-5 sm:w-6 sm:h-6 mb-2 ${item.color}`} />
                                    <span className="text-xs sm:text-sm text-neutral-700 text-center" 
                                          style={{ fontFamily: 'Georgia, serif' }}>
                                        {item.text}
                                    </span>
                                </div>
                            ))}
                        </div>

                        {/* CTA Button */}
                        <button
                            onClick={() => document.getElementById('section-smartphones')?.scrollIntoView({ behavior: 'smooth' })}
                            className="inline-flex items-center gap-2 sm:gap-3 px-6 sm:px-8 py-3 sm:py-4 text-xs sm:text-sm uppercase tracking-wider text-neutral-200 font-medium transition-all hover:scale-[1.02] hover:shadow-lg bg-neutral-900 border border-neutral-900 rounded-lg"
                            style={{ fontFamily: 'Georgia, serif' }}
                        >
                            Explore Products
                            <ChevronRight size={16} className='sm:w-5 sm:h-5' />
                        </button>
                    </div>
                </div>
            </section>

            {/* Featured Deals Banner */}
            <div className="bg-white border-t border-b border-neutral-300">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
                    <FeaturedDealsBanner onViewAllDeals={() => navigate('/flashdeals')} />
                </div>
            </div>

            {/* Category List */}
            <section className="py-8 sm:py-12 lg:py-16 bg-neutral-50">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="mb-6 sm:mb-8">
                        <h2 
                            className="text-xl sm:text-2xl lg:text-3xl font-normal text-neutral-900 tracking-tight mb-3"
                            style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                        >
                            Shop by Category
                        </h2>
                        <div className="h-px w-12 sm:w-16 bg-neutral-300" />
                    </div>
                    <CategoryList />
                </div>
            </section>

            {/* Banner Product */}
            <section className="py-8 sm:py-12 lg:py-16 bg-white">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <BannerProduct />
                </div>
            </section>

            {/* Product Sections */}
            <div className="bg-neutral-50">
                {/* Smartphones */}
                <ProductSection
                    id="smartphones"
                    title="Latest Smartphones"
                    emoji="📱"
                    description="Cutting-edge smartphones from Apple, Samsung, Google and more"
                    component={HorizontalCardProduct}
                    props={{
                        productsCategory: "smartphones",
                        heading: "Premium Smartphones"
                    }}
                    isVisible={visibleSections.smartphones}
                    isVertical={false}
                />

                {/* Laptops */}
                <ProductSection
                    id="laptops"
                    title="Powerful Laptops"
                    emoji="💻"
                    description="High-performance laptops for work, creativity, and gaming"
                    component={HorizontalCardProduct}
                    props={{
                        productsCategory: "laptops",
                        heading: "Laptops & Notebooks"
                    }}
                    isVisible={visibleSections.laptops}
                    isVertical={false}
                />

                {/* Tablets */}
                <ProductSection
                    id="tablets"
                    title="Versatile Tablets"
                    emoji="📟"
                    description="Perfect blend of productivity and entertainment"
                    component={VerticalCardProduct}
                    props={{
                        productsCategory: "tablets",
                        heading: "Tablets & iPads"
                    }}
                    isVisible={visibleSections.tablets}
                    isVertical={true}
                />

                {/* Smart Watches */}
                <ProductSection
                    id="smartwatches"
                    title="Smart Watches"
                    emoji="⌚"
                    description="Stay connected and track your fitness with style"
                    component={VerticalCardProduct}
                    props={{
                        productsCategory: "smart-watches",
                        heading: "Smart Watches"
                    }}
                    isVisible={visibleSections.smartwatches}
                    isVertical={true}
                />

                {/* Drones */}
                <ProductSection
                    id="drones"
                    title="Professional Drones"
                    emoji="🚁"
                    description="Capture stunning aerial photography and videography"
                    component={VerticalCardProduct}
                    props={{
                        productsCategory: "drones",
                        heading: "DJI Drones"
                    }}
                    isVisible={visibleSections.drones}
                    isVertical={true}
                />

                {/* Accessories */}
                <ProductSection
                    id="accessories"
                    title="Tech Accessories"
                    emoji="🔌"
                    description="Essential accessories to enhance your devices"
                    component={VerticalCardProduct}
                    props={{
                        productsCategory: "accessories",
                        heading: "Chargers & Powerbanks"
                    }}
                    isVisible={visibleSections.accessories}
                    isVertical={true}
                />

                {/* Games Consoles */}
                <ProductSection
                    id="games"
                    title="Gaming Consoles"
                    emoji="🎮"
                    description="Next-gen gaming experience for enthusiasts"
                    component={VerticalCardProduct}
                    props={{
                        productsCategory: "games-consoles",
                        heading: "Gaming & VR"
                    }}
                    isVisible={visibleSections.games}
                    isVertical={true}
                />
            </div>

            {/* Newsletter */}
            <section className="py-8 sm:py-12 lg:py-16 bg-white">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    {visibleSections.newsletter ? (
                        <div className="animate-fadeIn">
                            <NewsletterBox />
                        </div>
                    ) : (
                        <div className="h-32 sm:h-40 bg-neutral-100 rounded-lg animate-pulse"></div>
                    )}
                </div>
            </section>

            <style jsx>{`
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .animate-fadeIn {
                    animation: fadeIn 0.5s ease-out;
                }

                .scrollbar-none {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
                
                .scrollbar-none::-webkit-scrollbar {
                    display: none;
                }

                @media (max-width: 640px) {
                    .container {
                        overflow-x: hidden;
                    }
                }
            `}</style>
        </div>
    );
}

export default LandingPage;

// import React, { useState, useEffect, useMemo } from 'react';
// import CategoryList from '../../components/CategoryList/CategoryList';
// import BannerProduct from '../../components/BannerProduct/BannerProduct';
// import HorizontalCardProduct from '../../components/HorizontalCardProduct/HorizontalCardProduct';
// import VerticalCardProduct from '../../components/VerticalCardProduct/VerticalCardProduct';
// import NewsletterBox from '../../components/NewsletterBox/NewsletterBox';
// import { useTheme } from '../../components/Theme/ThemeProvider';
// import { useNavigate } from 'react-router-dom';
// import { ArrowLeft } from 'lucide-react';

// function LandingPage() {
//     const { colors } = useTheme();
//     const navigate = useNavigate();
//     const [visibleSections, setVisibleSections] = useState({
//         banner: true,
//         smartphones: false,
//         tablets: false,
//         laptops: false,
//         smartwatches: false,
//         drones: false,
//         accessories: false,
//         games: false,
//         newsletter: false
//     });

//     // Memoize category arrays for product sections
//     const smartphoneBrands = useMemo(() => ["iphone", "samsung", "oppo", "infinix", "google-pixel"], []);
//     const tabletBrands = useMemo(() => ["ipads", "samsung-tablets", "xiomi-tabs"], []);
//     const laptopBrands = useMemo(() => ["apple-laptop", "microsoft-surface", "hp", "dell", "lenovo", "msi"], []);
//     const watchBrands = useMemo(() => ["iwatches", "samsung-watches"], []);
//     const gameConsoles = useMemo(() => ["playstation", "xbox", "meta-quest", "nintendo-switch"], []);
//     const accessories = useMemo(() => ["chargers", "powerbanks"], []);

//     useEffect(() => {
//         // Load first sections immediately
//         setVisibleSections(prev => ({
//             ...prev,
//             smartphones: true,
//             laptops: true
//         }));

//         // Lazy load the rest
//         const timer = setTimeout(() => {
//             setVisibleSections(prev => ({
//                 ...prev,
//                 tablets: true,
//                 smartwatches: true,
//                 drones: true,
//                 accessories: true,
//                 games: true,
//                 newsletter: true
//             }));
//         }, 300);

//         return () => clearTimeout(timer);
//     }, []);

//     // Section skeleton loader
//     const SectionSkeleton = () => (
//         <div className="space-y-4">
//             <div className="h-8 bg-slate-200 dark:bg-slate-800 rounded w-1/3 animate-pulse"></div>
//             <div className="flex gap-4 overflow-hidden">
//                 {[...Array(4)].map((_, i) => (
//                     <div key={i} className="min-w-[280px] h-48 bg-slate-200 dark:bg-slate-800 rounded-lg animate-pulse"></div>
//                 ))}
//             </div>
//         </div>
//     );

//     // Product section wrapper
//     const ProductSection = ({ 
//         id, 
//         title, 
//         emoji, 
//         description, 
//         component: Component, 
//         props, 
//         isVisible 
//     }) => (
//         <section 
//             id={`section-${id}`}
//             className="mb-12 transition-opacity duration-500"
//             style={{ backgroundColor: colors.bg }}
//         >
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                 {/* Section Header */}
//                 <div className="mb-8">
//                     <div className="flex items-center gap-3 mb-3">
//                         <h2 
//                             className="text-3xl md:text-4xl font-black"
//                             style={{ color: colors.text }}
//                         >
//                             <span className="mr-3">{emoji}</span>
//                             {title}
//                         </h2>
//                     </div>
//                     <p 
//                         className="text-lg"
//                         style={{ color: colors.textSecondary }}
//                     >
//                         {description}
//                     </p>
//                     <div 
//                         className="h-1 w-20 mt-4 rounded-full"
//                         style={{ backgroundColor: colors.primary }}
//                     />
//                 </div>

//                 {/* Content */}
//                 {isVisible ? (
//                     <div className="animate-fadeIn">
//                         <Component {...props} />
//                     </div>
//                 ) : (
//                     <SectionSkeleton />
//                 )}
//             </div>
//         </section>
//     );

//     const goBack = ()=>{
//         navigate("/landing");
//     }

//     return (
//         <div 
//             style={{ 
//                 backgroundColor: colors.bg, 
//                 minHeight: '100vh',
//                 transition: 'background-color 0.3s ease'
//             }}
//         >
            
//             {/* Hero Section */}
//             <section
//                 className="relative overflow-hidden pt-24 pb-16 md:pt-32 md:pb-24"
//                 style={{
//                     background: `linear-gradient(135deg, ${colors.primaryLight} 0%, ${colors.accentLight} 100%)`
//                 }}
//             >
//                 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                     <button onClick={goBack} className="mb-8 text-white font-semibold underline">
//                     <ArrowLeft className="inline-block w-4 h-4 ml-1" /> Go Back 
//                     </button>
//                     <div className="text-center">
//                         <h1
//                             className="text-5xl md:text-6xl font-black mb-6 leading-tight"
//                             style={{ color: colors.text }}
//                         >
//                             Discover Your <span style={{ color: colors.primary }}>Next</span> Favorite
//                         </h1>
//                         <p
//                             className="text-xl md:text-2xl mb-8 max-w-2xl mx-auto"
//                             style={{ color: colors.textSecondary }}
//                         >
//                             Shop premium phones and gadgets with exclusive deals
//                         </p>
//                         <div 
//                             className="inline-block px-8 py-3 rounded-full font-bold text-white animate-pulse"
//                             style={{ backgroundColor: colors.primary }}
//                         >
//                             New Arrivals Added Daily
//                         </div>
//                     </div>
//                 </div>
//             </section>

//             {/* Category List - Always visible */}
//             <section 
//                 className="py-12"
//                 style={{ backgroundColor: colors.bgSecondary }}
//             >
//                 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                     <h2 
//                         className="text-3xl font-black mb-8"
//                         style={{ color: colors.text }}
//                     >
//                         Browse by Category
//                     </h2>
//                     <CategoryList />
//                 </div>
//             </section>

//             {/* Banner - Always visible */}
//             <section className="py-12" style={{ backgroundColor: colors.bg }}>
//                 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                     <BannerProduct />
//                 </div>
//             </section>

//             {/* Lazy Loaded Product Sections */}
//             <div style={{ backgroundColor: colors.bg }}>
//                 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
//                     {/* Smartphones */}
//                     <ProductSection
//                         id="smartphones"
//                         title="Latest Smartphones"
//                         emoji="📱"
//                         description="Cutting-edge smartphones from top brands"
//                         component={HorizontalCardProduct}
//                         props={{
//                             productsCategory: smartphoneBrands,
//                             heading: "Premium Smartphones"
//                         }}
//                         isVisible={visibleSections.smartphones}
//                     />

//                     {/* Laptops */}
//                     <ProductSection
//                         id="laptops"
//                         title="Powerful Laptops"
//                         emoji="💻"
//                         description="High-performance laptops for work and gaming"
//                         component={HorizontalCardProduct}
//                         props={{
//                             productsCategory: laptopBrands,
//                             heading: "Laptops & Notebooks"
//                         }}
//                         isVisible={visibleSections.laptops}
//                     />

//                     {/* Tablets */}
//                     <ProductSection
//                         id="tablets"
//                         title="Versatile Tablets"
//                         emoji="📟"
//                         description="Perfect blend of productivity and entertainment"
//                         component={VerticalCardProduct}
//                         props={{
//                             productsCategory: tabletBrands,
//                             heading: "Tablets & iPads"
//                         }}
//                         isVisible={visibleSections.tablets}
//                     />

//                     {/* Smart Watches */}
//                     <ProductSection
//                         id="smartwatches"
//                         title="Smart Watches"
//                         emoji="⌚"
//                         description="Stay connected and track your fitness"
//                         component={VerticalCardProduct}
//                         props={{
//                             productsCategory: watchBrands,
//                             heading: "Smart Watches"
//                         }}
//                         isVisible={visibleSections.smartwatches}
//                     />

//                     {/* Drones */}
//                     <ProductSection
//                         id="drones"
//                         title="Professional Drones"
//                         emoji="🚁"
//                         description="Capture stunning aerial photography"
//                         component={VerticalCardProduct}
//                         props={{
//                             productsCategory: ["dji-drones"],
//                             heading: "DJI Drones"
//                         }}
//                         isVisible={visibleSections.drones}
//                     />

//                     {/* Accessories */}
//                     <ProductSection
//                         id="accessories"
//                         title="Tech Accessories"
//                         emoji="🔌"
//                         description="Essential accessories for your devices"
//                         component={VerticalCardProduct}
//                         props={{
//                             productsCategory: accessories,
//                             heading: "Chargers & Powerbanks"
//                         }}
//                         isVisible={visibleSections.accessories}
//                     />

//                     {/* Games Consoles */}
//                     <ProductSection
//                         id="games"
//                         title="Gaming Consoles"
//                         emoji="🎮"
//                         description="Next-gen gaming experience"
//                         component={VerticalCardProduct}
//                         props={{
//                             productsCategory: gameConsoles,
//                             heading: "Gaming & VR"
//                         }}
//                         isVisible={visibleSections.games}
//                     />
//                 </div>
//             </div>

//             {/* Newsletter */}
//             <section 
//                 id="section-newsletter"
//                 className="py-12"
//                 style={{ 
//                     background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.accent} 100%)`
//                 }}
//             >
//                 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                     {visibleSections.newsletter ? (
//                         <div className="animate-fadeIn">
//                             <NewsletterBox />
//                         </div>
//                     ) : (
//                         <div className="h-32 bg-white/10 rounded-lg animate-pulse"></div>
//                     )}
//                 </div>
//             </section>

//             <style jsx>{`
//                 @keyframes fadeIn {
//                     from {
//                         opacity: 0;
//                     }
//                     to {
//                         opacity: 1;
//                     }
//                 }

//                 .animate-fadeIn {
//                     animation: fadeIn 0.5s ease-out;
//                 }

//                 @keyframes pulse {
//                     0%, 100% {
//                         opacity: 1;
//                     }
//                     50% {
//                         opacity: 0.5;
//                     }
//                 }

//                 .animate-pulse {
//                     animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
//                 }
//             `}</style>
//         </div>
//     );
// }

// export default LandingPage;